export default {"src":"/_next/static/media/image.5b6510cd.svg","height":16,"width":17};